import CartContent from "./cart-content";

export default CartContent;